module.exports = __webpack_public_path__ + "img/logo.95a849c5.svg";